import React, { createContext, useContext, useState, ReactNode } from 'react'
import styled, { CSSProperties } from 'styled-components'

type TabsContextType = {
  activeValue: string
  onValueChange: (value: string) => void
}

const TabsContext = createContext<TabsContextType | undefined>(undefined)

const TabsWrapper = styled.div`
  width: 100%;
  
`

const TabsListWrapper = styled.div`
  display: flex;
  width: 100%;
  border-bottom: 1px solid rgb(232 232 232);
  border-top: 1px solid rgb(232 232 232);
  background-color: rgb(250 250 250);
  z-index: 110;
`

const TabButton = styled.button<{ active: boolean }>`
  flex: 1;
  padding: 0.75rem 0px;
  text-align: center;
  background: none;
  border: none;
  border-bottom: 2px solid transparent;
  position: relative;
  cursor: pointer;
  font-weight: bold;
  font-size: 14px;
  color: ${({ active }) => (active ? 'rgb(108, 92, 231)' : '#6b7280')};
  border-bottom-color: ${({ active }) => (active ? 'rgb(108, 92, 231)' : 'transparent')};
  transition: all 0.2s ease;

  &:hover {
    color: rgb(108, 92, 231);
    i:before {
      background-color:  rgb(108, 92, 231);
    }
  }

  ${({ active }) => (active ?
    `
    background-color: white;
    &:after {
      content: "";
      display: block;
      position: absolute;
      left: 0px;
      bottom: 0px;
      width: 100%;
      height: 2px;
      margin-bottom: -1px;
      border-radius: 2px 2px 0px 0px;
      background-color: rgb(108, 92, 231);
    }` : ''
  )};
  }
`

const TabsContentWrapper = styled.div`
 
`

type TabsProps = {
  value?: string
  defaultValue?: string
  onValueChange?: (value: string) => void
  children: ReactNode
}

export const Tabs: React.FC<TabsProps> = ({
  value,
  defaultValue,
  onValueChange,
  children,
}) => {
  const [internalValue, setInternalValue] = useState(defaultValue || '')
  const activeValue = value !== undefined ? value : internalValue

  const handleValueChange = (newValue: string) => {
    if (onValueChange) onValueChange(newValue)
    else setInternalValue(newValue)
  }

  return (
    <TabsContext.Provider value={{ activeValue, onValueChange: handleValueChange }}>
      <TabsWrapper>{children}</TabsWrapper>
    </TabsContext.Provider>
  )
}

type TabsListProps = {
  children: ReactNode
}

export const TabsList: React.FC<TabsListProps> = ({ children }) => {
  return <TabsListWrapper>{children}</TabsListWrapper>
}

type TabsTriggerProps = {
  value: string
  disabled?: boolean
  children: ReactNode
}

export const TabsTrigger: React.FC<TabsTriggerProps> = ({ value, disabled, children }) => {
  const context = useContext(TabsContext)
  if (!context) {
    throw new Error('TabsTrigger debe estar dentro de un Tabs')
  }

  const { activeValue, onValueChange } = context
  const isActive = activeValue === value

  return (
    <TabButton
      active={isActive}
      type="button"
      onClick={() => !disabled && onValueChange(value)}
    >
      {children}
    </TabButton>
  )
}

type TabsContentProps = {
  value: string
  children: ReactNode
  style?: CSSProperties
}

export const TabsContent: React.FC<TabsContentProps> = ({ value, children, style }) => {
  const context = useContext(TabsContext)
  if (!context) {
    throw new Error('TabsContent debe estar dentro de un Tabs')
  }

  const { activeValue } = context
  if (activeValue !== value) return null

  return <TabsContentWrapper style={style}>{children}</TabsContentWrapper>
}
